import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AmplifyAuthService } from '../services/amplify-auth.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard  {
  constructor(
    private router: Router,
    private amplifyAuth: AmplifyAuthService
  ) {
  }

  canActivate(): Promise<boolean> {
    return new Promise((resolve) => {
      this.amplifyAuth.fetchAuthSession({ forceRefresh: false }).then((session) => {
        if (session.tokens?.idToken) {
          resolve(true);
        } else {
          this.router.navigate(['/login']);
          resolve(false);
        }
      }).catch(() => {
        this.router.navigate(['/login']);
        resolve(false);
      });
    });
  }
}

